import React, { useContext, useEffect, useState } from 'react';
import { CardHeader, CardSection } from '@europrocurement/flexy-components';
import { DOC_TYPE_INTERNAL } from '@europrocurement/l2d-domain';
import { DocumentContext } from '../../../providers';
import RequiredDocumentsList from '../RequiredDocumentsList/RequiredDocumentsList';
import useDossierFile from '../../../hooks/useDossierFile';
import RequiredDocumentUploader from '../RequiredDocumentUploader/RequiredDocumentUploader';
import { DisplayedDocument } from '../../../providers/types';

const InternalDocumentsTab: React.FunctionComponent<React.PropsWithChildren> = function ({
    children,
}) {
    const [listItems, setListItems] = useState<Array<DisplayedDocument>>([]);
    const [uploadingAdditionalDocument, setUploadingAdditionalDocument] = useState<boolean>(false);
    const { documents, fichiers, getInternalDocuments, getInternalAdditionalDocuments } =
        useContext(DocumentContext);
    const {
        handleAddFile,
        handleRemoveFile,
        handleShow,
        handleDownload,
        handleAdditionalUploads,
        handleMoveFile,
    } = useDossierFile({
        listItems,
        setListItems,
        typeDoc: DOC_TYPE_INTERNAL,
        setUploadingAdditionalDocument,
    });

    useEffect(() => {
        setListItems([...getInternalDocuments(), ...getInternalAdditionalDocuments()]);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [documents, fichiers]);

    return (
        <CardSection
            header={
                <CardHeader
                    title="Documents internes"
                    titleSx={{
                        fontSize: '20px',
                        lineHeight: '28px',
                    }}
                    border={false}
                />
            }
            sxContent={{
                padding: '8px 32px 32px',
                display: 'flex',
                flexDirection: 'column',
                gap: '24px 0',
            }}
        >
            <RequiredDocumentsList
                documents={listItems}
                onUpload={handleAddFile}
                onDeletion={handleRemoveFile}
                onDownload={handleDownload}
                onShow={handleShow}
                onMove={handleMoveFile}
            />

            <RequiredDocumentUploader
                uploading={uploadingAdditionalDocument}
                onChange={handleAdditionalUploads}
                typeDoc={DOC_TYPE_INTERNAL}
                additionnalAccept=",application/vnd.ms-outlook,.msg"
            />

            {children}
        </CardSection>
    );
};

export default InternalDocumentsTab;
